import React from "react";

export default function About() {
  return (
    <section id="about" className="about-section text-white text-center py-5">
      <div className="container">
        <h2 className="fw-bold mb-4">دەربارەی ئێمە</h2>
        <p>
          ئەپی یاسا لاپەڕەیەکی نوێیە لە دونیای یاساناساندا لە هەرێمی کوردستان
        </p>
        <p>
       پردی گەیاندنی هاوڵاتیانە بە پارێزەرانەوە
        </p>
        <p>
هاوڵاتی دەتوانێت لە ماوەیەکی کورتدا پەیوەندی بە هەر پارێزەرێکەوە بکات و کێشە یاساییەکانی بۆ باس بکات
        </p>
      </div>
    </section>
  );
}
